import { useAuth } from "contexts";

export default function useSignIn() {
  const { login, loading } = useAuth();

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    login(values.email, values.password).catch((error) => {
      console.error("Login error:", error);
      setSubmitting(false);
    });
  };

  return {
    initialValues,
    onSubmit,
    loading,
  };
}

const initialValues = {
  email: "",
  password: "",
  rememberMe: false,
};
